export const HITO_TIPOS = `
  query hitoTipos(
    $tenant_id: Int!,
    $skip: Int,
    $take: Int,
    $orderBy: HitoTipoOrderInput,
    $filter: FilterHitoTipoInput,
    $searchText: String
  ) {
    hitoTipos(
      tenant_id: $tenant_id,
      skip: $skip,
      take: $take,
      orderBy: $orderBy,
      filter: $filter,
      searchText: $searchText
    ) {
      __typename
      ... on HitoTipo {
        id
        name
        code
        category_hito
        description
        vigencia_type
        requires_year
        impact_type
        allow_event
        en_timeline
        icon
        subtype_enabled
        active
        vistage20_id
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const HITO_TIPO = `
  query hitoTipo($tenant_id: Int!, $id: Int!) {
    hitoTipo(tenant_id: $tenant_id, id: $id) {
      __typename
      ... on HitoTipo {
        id
        name
        code
        category_hito
        description
        vigencia_type
        requires_year
        impact_type
        allow_event
        en_timeline
        icon
        subtype_enabled
        active
        vistage20_id
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
